module.exports = __webpack_public_path__ + "img/icon-cantine.6ae5168a.svg";